import React from 'react';
import { trackPixelEvent } from './MetaPixel';
export function Countdown() {
  return <section className="bg-red-600 text-white py-10 px-6 text-center" data-id="element-35">
      <h3 className="text-2xl font-bold mb-2" data-id="element-36">
        ⏰ El precio de lanzamiento termina en:
      </h3>
      <div className="flex justify-center gap-4 mt-4 mb-6" data-id="element-37">
        {['23 HS', '55 MIN', '51 SEG'].map(unit => <div key={unit} className="bg-white text-red-600 font-extrabold text-2xl px-6 py-3 rounded-xl" data-id="element-38">
            {unit}
          </div>)}
      </div>
      <p className="text-red-100 text-sm mb-4" data-id="element-39">
        Después sube $10.000 ARS y no vuelve a bajar.
      </p>
      <div className="max-w-xs mx-auto bg-red-700 rounded-full h-3 mb-2" data-id="element-40">
        <div className="bg-white h-3 rounded-full" style={{
        width: '68%'
      }} data-id="element-41" />
      </div>
      <p className="text-sm text-red-100" data-id="element-42">
        68% de los cupos al precio de lanzamiento ya tomados
      </p>
      <a href="#precios" onClick={() => trackPixelEvent('Lead', {
      content_name: 'Countdown CTA',
      content_category: 'Pack de Inglés 360'
    })} className="inline-block mt-6 bg-white text-red-600 font-bold py-3 px-8 rounded-full hover:bg-red-50 transition" data-id="element-43">
        → ASEGURAR MI PRECIO AHORA
      </a>
    </section>;
}